module.exports = __webpack_public_path__ + "static/media/6H.13bea5a1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/6H.svg
// module id = 71
// module chunks = 0